import React from 'react';
import styled from 'styled-components';
import { testId } from '@lojinha/helpers';
import { tabNavigationStyle } from '../../helpers/tabNavigationStyle';
const Notification = styled.div(({ theme }) => `
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${theme.space.x16};
    min-width: ${theme.space.x16};
    font-size: ${theme.fontSizes.x0};
    color: ${theme.colors.white};
    background-color: ${theme.colors.success};
    border: none;
    cursor: pointer;
    border-radius: ${theme.space.x4};
    padding: ${theme.space.x4};
    position: absolute;
    left: 2px;
    top: 10px;
  `);
const iconHovered = (hoverEnabled, color) => {
    if (hoverEnabled)
        return `
      svg {
        path {
          fill: ${color};
          transition: fill 200ms ease;
        }
      }
    `;
    return '';
};
const backgroundHovered = (hoverEnabled, color) => {
    if (hoverEnabled)
        return `
      background-color: ${color};
      transition: background-color 200ms ease;
    `;
    return '';
};
const roundedBackground = (hasRoundedBackground, color) => {
    if (hasRoundedBackground)
        return `
    background-color: ${color};
    border-radius: 50%;
  `;
    return '';
};
const Component = styled.button(({ theme }) => `
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: ${theme.space.x48};
    height: ${theme.space.x48};
    border: none;
    cursor: pointer;
    border-radius: 8px;
    background-color: ${theme.colors.transparent};
    transition: transform 300ms cubic-bezier(0.22, 1, 0.36, 1), background-color 200ms ease;
  `, ({ theme, isDisabled, enabledIconHover, enabledIconBackgroundHover, hasRoundedBackground, }) => isDisabled
    ? `
        cursor: not-allowed;
        ${roundedBackground(hasRoundedBackground, theme.colors.gray100)};

        svg {
          path {
            fill: ${theme.colors.gray200};
          }
        }
      `
    : `
        ${roundedBackground(hasRoundedBackground, theme.colors.gray100)};

        &:hover {
          ${backgroundHovered(enabledIconBackgroundHover, theme.colors.gray100)};

          ${iconHovered(enabledIconHover, theme.colors.success)};
        }

        &:active {
          transform: scale(0.9);
          transition: transform 300ms cubic-bezier(0.22, 1, 0.36, 1);

          ${iconHovered(enabledIconHover, theme.colors.success)};
        }
      `, tabNavigationStyle);
export const ButtonIcon = ({ htmlAttrs = {}, ariaLabel, role, onClick, icon, notification, isDisabled, enabledIconHover = true, enabledIconBackgroundHover = true, hasRoundedBackground = false, ...rest }) => (React.createElement(Component, { ...htmlAttrs, onClick: onClick, "aria-label": ariaLabel, role: role, isDisabled: isDisabled, disabled: isDisabled, enabledIconHover: enabledIconHover, enabledIconBackgroundHover: enabledIconBackgroundHover, hasRoundedBackground: hasRoundedBackground, ...rest },
    notification && (React.createElement(Notification, { ...testId('button-icon-notification') }, notification)),
    icon));
//# sourceMappingURL=index.js.map